<table class="ir-plugin-table" style="margin-bottom: 10px" *ngFor="let item of checkedValues">
  <tr *ngIf="item.Label">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ item.Label }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1 ir-installationreceived_comment"></span>
      </p>
    </td>
  </tr>
  <tr *ngIf="item.Status && item.Status >= 0">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationchecked.status' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ item.Status | checkedstatus }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="item.Comment">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationchecked.comment' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-installationreceived_comment ir-ph1" [innerHtml]="item.Comment"></span>
      </p>
    </td>
  </tr>
</table>
